import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
  import useBreakpoint from '@/composables/useBreakpoint'
  import useIcons from '@/composables/useIcons'
  import useCuratedContent from '@/composables/useCuratedContent'
  import CarouselSwiper from '@/components/common/CarouselSwiper.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import PlaceholderShimmer from '@/components/common/PlaceholderShimmer.vue'
  import InterestedCategories from '@/components/common/InterestedCategories.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import RootFoldersApi from '@/services/api/RootFoldersApi'
  import eventBus from '@/main'
  import useI18n from '@/composables/useI18n'
  import type { ContentItem } from '@/services/interfaces/Content'
  import useCommonMixin from '@/composables/useCommonMixin'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'InterestedCategoriesContents',
  setup(__props) {

  const { actualContentItems, getPosterImageUrl, itemHasImage, getYoutubeId, fetchInterestedCategories } =
    useCuratedContent()
  const { leftNavigation, rightNavigation, categoryInterestImage } = useIcons()
  const { translateString } = useI18n()
  const { isMobileDevice, isSmallerMobileDevice } = useBreakpoint()
  const { setIsLoadingComponentViewData } = useCommonMixin()
  const rerenderKey = ref('')

  const breakPoints = {
    1200: {
      slidesPerView: '4',
      spaceBetween: '30',
      slidesPerGroup: '4',
    },
    1024: {
      slidesPerView: '3.2',
      spaceBetween: '30',
      slidesPerGroup: '3',
    },
    991: {
      slidesPerView: '2.45',
      spaceBetween: '30',
      slidesPerGroup: '3',
    },
    767: {
      slidesPerView: '2.2',
      spaceBetween: '20',
      slidesPerGroup: '2',
    },
    540: {
      slidesPerView: '1.2',
      spaceBetween: '15',
      slidesPerGroup: '1',
    },
  }

  const contentItems = computed(() => {
    if (!actualContentItems.value) return null
    return actualContentItems.value
      .map((item) => {
        return {
          rootFolder: item.rootFolder,
          content: item.content.filter((i) => itemHasImage(i)),
        }
      })
      .filter((item) => item.content.length)
  })

  const loadingContentItems = computed(() => contentItems.value === null)

  const launchYoutubeModal = (item: ContentItem): void => {
    const youtubeId = getYoutubeId(item.contentUrl!)
    if (youtubeId) {
      eventBus.$emit('show-modal', {
        modalContentComponent: 'YoutubeModal',
        cssClass: 'youtube',
        modalProps: {
          videoId: youtubeId,
          contentId: item.id,
        },
        modalCloseCallback: (callback: () => void) => {
          if (typeof callback === 'function') callback()
        },
      })
    }
  }

  const loadedImages: string[] = []
  const onImageLoad = (id: string, onResourceLoaded: () => void): void => {
    loadedImages.push(id)
    onResourceLoaded()
  }

  const imageLoaded = computed(() => {
    return (id: string): boolean => {
      return loadedImages.includes(id)
    }
  })

  const selectedInterestedCategories = ref([] as string[])
  const isPostingInterests = ref(false)
  const postInterestedCategories = () => {
    if (selectedInterestedCategories.value.length) {
      isPostingInterests.value = true
      RootFoldersApi.postInterestedCategories(selectedInterestedCategories.value).finally(() => {
        isPostingInterests.value = false
        fetchInterestedCategories()
      })
    } else {
      eventBus.$toasted.error(translateString('homepage.selectAnOption'))
    }
  }

  watch(isMobileDevice, () => {
    rerenderKey.value = Math.random().toString()
  })

  watch(loadingContentItems, (value) => {
    setIsLoadingComponentViewData(value)
  })

return { __sfc: true,actualContentItems, getPosterImageUrl, itemHasImage, getYoutubeId, fetchInterestedCategories, leftNavigation, rightNavigation, categoryInterestImage, translateString, isMobileDevice, isSmallerMobileDevice, setIsLoadingComponentViewData, rerenderKey, breakPoints, contentItems, loadingContentItems, launchYoutubeModal, loadedImages, onImageLoad, imageLoaded, selectedInterestedCategories, isPostingInterests, postInterestedCategories, computed, ref, watch, useBreakpoint, useIcons, useCuratedContent, CarouselSwiper, LoadingSpinner, PlaceholderShimmer, InterestedCategories, KetchUpButton, RootFoldersApi, eventBus, useI18n, useCommonMixin }
}

})